import { render } from "./UserProfilePicture.vue?vue&type=template&id=3512d40c&ts=true"
import script from "./UserProfilePicture.vue?vue&type=script&lang=ts"
export * from "./UserProfilePicture.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__